.popover {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: var(--z-popover);
  width: 300px;
  max-width: calc(100vw - 2 * var(--space-4));
  padding: var(--space-2);
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-pop);
}

.popover:focus {
  outline: none;
}

.alignEnd {
  right: 0;
  left: auto;
}
